export const API_URL =
  document.body.dataset.env === 'prod'
    ? `https://api.regionaler-strommarkt.de/api`
    : 'https://qas.api.regionaler-strommarkt.de/api';
    //: 'https://dev.api.regionaler-strommarkt.de/api';
